export const shouldShowTimeSlot = (showType, diffDays, diffMinutes) => {
  if (showType !== 'add') return false;
  if (diffDays < 0) return false;
  if (diffMinutes < 0) return false;
  return true;
};